import React from "react"
import { getValidateData } from "./Utilities"

export default class Form extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: props.data || {},
            validateData: {}
        }
    }
    removeFormData = () => {
        this.setState({ data: {} })
    }
    setValue = (field, value) => {
        let { data } = this.state;
        data[field] = value;
        this.setState({ data });
        this.props.setValue && this.props.setValue(this.props.field, data);
    }

    setValidateData = (field, value) => {
        let { validateData } = this.state;
        validateData[field] = value;
        this.setState({ validateData });

    }
    removeValidateData = field => {
        let { validateData } = this.state
        if (validateData[field]) {
            delete validateData[field];
            this.setState({ validateData })
        }
    }

    onSubmit = () => {
        let { data, validateData } = this.state || {};
        let { mandatoryFields, onSubmit } = this.props;
        let validationDataOnSave = getValidateData({ data, mandatoryFields, validateData });
        if (Object.keys(validationDataOnSave).length > 0) {
            this.setState({ validateData: validationDataOnSave });
            return;
        }
        if (Object.keys(validateData).length > 0) {
            return;
        }

        else {
            onSubmit && onSubmit(data);
        }
    }
    render() {
        let { editable, mandatoryFields, children } = this.props;

        let childProps = {
            setValue: this.setValue,
            data: this.state.data,
            mandatoryFields,
            setValidateData: this.setValidateData,
            validateData: this.state.validateData,
            removeFormData: this.removeFormData,
            removeValidateData: this.removeValidateData,
            onSubmit: this.onSubmit
        }

        if (editable !== undefined) {
            childProps.editable = editable;
        }

        if (typeof children === "function") {
            return children({
                ...childProps
            })
        }

        return (
            <div autoComplete={"off"} className="flex-1">
                {Array.isArray(children) ? children.map((child, index) => {
                    return (
                        React.cloneElement(child, {
                            key: index,
                            ...childProps
                        })
                    )
                }) :
                    React.cloneElement(children, {
                        ...childProps
                    })}
            </div>
        )
    }
}



